var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAgi(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 32,
    viewBox: "0 0 32 32",
    width: 32,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    fill: "#6916ff",
    r: 16
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.144 6.424a.28.28 0 01-.081-.363.289.289 0 01.312 0 5.63 5.63 0 011.875 1.272c.303.281.557.609.75.97.204.368.371.753.5 1.152.123.413.187.842.188 1.272-.063.425-.125 2.485-1.313 3.455a.714.714 0 01-.938-.182.627.627 0 01-.062-.727A5.047 5.047 0 0018.5 8c-.4-.566-.854-1.093-1.356-1.576zM15.3 25.006c.125.121.125.242.063.303s-.188.121-.25.06a5.63 5.63 0 01-1.875-1.272 3.709 3.709 0 01-.75-.97 6.463 6.463 0 01-.5-1.151 4.482 4.482 0 01-.188-1.273c.063-.424.125-2.485 1.313-3.455a.714.714 0 01.937.182.539.539 0 010 .728 5.047 5.047 0 00-.125 5.272c.405.567.866 1.095 1.375 1.576z",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.694 20.006a5.473 5.473 0 00-1.313-3.151 10.816 10.816 0 00-2.625-1.94 14.466 14.466 0 01-2.375-1.642 4.032 4.032 0 01-1.187-2.121 4.243 4.243 0 01.306-2.48 6.692 6.692 0 011.756-2.242.26.26 0 00.063-.303.242.242 0 00-.375-.06 5.577 5.577 0 00-2.438 2.06 5.01 5.01 0 00-.881 3.273 5.25 5.25 0 00.438 1.697 6 6 0 001 1.455 10.78 10.78 0 002.687 1.878c.848.44 1.645.969 2.375 1.576a3.603 3.603 0 011.188 2.182c.176.879.066 1.79-.313 2.606a6.13 6.13 0 01-1.813 2.182.207.207 0 00-.063.303c.035.064.1.11.173.121s.149-.01.203-.06a7.801 7.801 0 002.375-2.122c.62-.958.906-2.084.819-3.212z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAgi);
export default __webpack_public_path__ + "static/media/agi.22629d5c6b7dbab2a605de0ca62caa13.svg";
export { ForwardRef as ReactComponent };